module.exports = __webpack_public_path__ + "media/images/bg/group-course-2ff404c0702ec1e4f09d7b094fe69465.svg";